export const getSteps = (offerType: string) => {
    switch (offerType.toLowerCase()) {
        case 'co':
            return [
                {
                    showDisclaimer: false,
                    organism: 'RefinanceForm',
                    stepTitle: 'Equity amount'
                },
                {
                    showDisclaimer: true,
                    organism: 'ReviewInformation',
                    stepTitle: 'Contact Information'
                }
            ];
        case 'pu':
            return [
                {
                    showDisclaimer: false,
                    organism: 'NewHomeInfoForm',
                    stepTitle: 'New Home Information'
                },
                {
                    showDisclaimer: true,
                    organism: 'PurchaseContactInfo',
                    stepTitle: 'Contact Information'
                }
            ];
        case 'sl':
        case 'rt':
            return [{ showDisclaimer: true, organism: 'RefiStreamline' }];
        default:
            return [{ showDisclaimer: false, organism: '' }];
    }
};

const CashoutSuccessMessage = 'Thank you for your request to get cash from your home’s equity. We will reach out to you soon.';
const RefinanceSuccessMessage = 'Thank you for submitting your request to refinance your home. We will reach out to you soon.';
const PurchaseSuccessMessage = 'Thank you for submitting your request to purchase a new home. We will reach out to you soon.';

const RefinanceErrorMessage = 'Something went wrong on our end. Please call 888-369-2807 to complete the request for your refinance.';

const CashoutErrorMessage = 'Something went wrong on our end. Please call 888-369-2807 to complete your request for a Cash Out Refinance.';
const PurchaseErrorMessage = 'Something went wrong on our end. Please call 888-369-2807 to complete your request for a new home purchase.';

const AuthenticatedLeadFormsConstants = {
    CashoutSuccessMessage,
    RefinanceSuccessMessage,
    CashoutErrorMessage,
    RefinanceErrorMessage,
    PurchaseErrorMessage,
    PurchaseSuccessMessage
};

export const SuccessMessage = (type: string) => {
    switch (type) {
        case 'AuthCashOut':
            return CashoutSuccessMessage;
        case 'AuthRefi':
            return RefinanceSuccessMessage;
        case 'AuthPurchase':
            return PurchaseSuccessMessage;
        default:
            return '';
    }
};
export const ErrorMessage = (type: string) => {
    switch (type) {
        case 'AuthCashOut':
            return CashoutErrorMessage;
        case 'AuthRefi':
            return RefinanceErrorMessage;
        case 'AuthPurchase':
            return PurchaseErrorMessage;
        default:
            return '';
    }
};
const AuthenticatedLeadFormsResponseFunctions = {
    SuccessMessage,
    ErrorMessage
};

export default AuthenticatedLeadFormsResponseFunctions;
